module.exports = __webpack_public_path__ + "img/T.a0291995.jpg";